<script setup lang="ts">
import type { TtLocationFragment } from '#graphql-operations'

const props = defineProps<{ store: TtLocationFragment | null }>()

const storeAdviceDialog = useUiDialog('store-advice-dialog')
const storePickupDialog = useUiDialog('store-pickup-dialog')
const storeContactDialog = useUiDialog('store-contact-dialog')

const currentAction = ref<string | null>(null)
const currentStore = computed<TtLocationFragment | null>(() => props.store)

const currentStoreBaseUrl = computed(() => currentStore.value ? `/winkels/${stringToSlug(currentStore.value.city)}` : null)

const saleUrl = computed(() => {
  return currentStore.value ? `${currentStoreBaseUrl.value}/sale/` : null
})
const stockUrl = computed(() => {
  return currentStore.value ? `${currentStoreBaseUrl.value}/voorraad/` : null
})
const outletUrl = computed(() => {
  return currentStore.value ? `${currentStoreBaseUrl.value}/outlet/` : null
})
const detailUrl = computed(() => {
  return currentStore.value ? currentStoreBaseUrl.value : null
})
const serviceUrl = computed(() => {
  return currentStore.value?.serviceUrl || `/serviceaanvraag/${stringToSlug(currentStore.value?.city || '')}`
})
const orderStatusUrl = computed(() => {
  return currentStore.value?.orderStatusUrl || null
})
const vacanciesUrl = computed(() => {
  return currentStore.value?.vacanciesUrl || null
})

const doAction = (action: string) => {
  currentAction.value = action

  if (action == 'Advice') {
    storeAdviceDialog.open()
  }
  else if (action == 'Contact') {
    storeContactDialog.open()
  }
  else if (action == 'Pickup') {
    storePickupDialog.open()
  }
  else if (action == 'Service') {
    navigateTo(serviceUrl.value)
  }
  else if (action == 'Details') {
    navigateTo(detailUrl.value)
  }
  else if (action == 'OrderStatus') {
    navigateTo(orderStatusUrl.value)
  }
  else if (action == 'Vacancies') {
    navigateTo(vacanciesUrl.value)
  }
  else if (action == 'Stock') {
    navigateTo(stockUrl.value)
  }
  else if (action == 'StockOutlet') {
    navigateTo(outletUrl.value)
  }
  else if (action == 'StockSale') {
    navigateTo(saleUrl.value)
  }
}
</script>

<template>
  <div>
    <slot
      :do-action="doAction"
      :stock-url="stockUrl"
      :sale-url="saleUrl"
      :outlet-url="outletUrl"
      :order-status-url="orderStatusUrl"
      :service-url="serviceUrl"
      :vacancies-url="vacanciesUrl"
    />

    <StoreAdviceDialog
      v-if="currentStore"
      :store="currentStore"
    />
    <StorePickupDialog
      v-if="currentStore"
      :store="currentStore"
    />
    <StoreContactDialog
      v-if="currentStore"
      :store="currentStore"
    />
  </div>
</template>
